import { Link } from "react-router-dom";
import { footerContact, footerItem } from "../data/Data";
/* import Newsletter from "../home/Newsletter"; */

export default function Footer() {
  return (
    <>
      {/* <Newsletter /> */}
      <div
        className="container-fluid bg-dark text-light footer wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container pb-5">
          <div className="row g-5">
            <div className="col-md-6 mt-0 col-lg-4">
              <div className="rounded p-4">
                <Link to="/">
                  <img
                    src="/assets/img/logo.svg"
                    alt="Logo"
                    className="img-fluid logo2"
                  />
                </Link>
                <p className="text-white mb-0">
                  Whether you’re here for a weekend getaway or an extended stay, you’ll enjoy a world-class experience that feels like home, but even better.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-lg-3">
              <h6 className="section-title text-start text-primary text-uppercase mb-4">
                Contact
              </h6>
              {footerContact.map((val, index) => (
                <p className="mb-2" key={index}>
                  {val.icon} {val.name}
                </p>
              ))}
              {/* <div className="d-flex pt-2">
                {socialIcons.slice(0, 4).map((val, index) => (
                  <a className="btn btn-outline-light btn-social" href="">
                    {val.icon}
                  </a>
                ))}
              </div> */}
            </div>
            <div className="col-lg-5 col-md-12">
              <div className="row gy-5 g-4">
                {footerItem.map((section, sectionIndex) => (
                  <div className="col-md-6" key={sectionIndex}>
                    <h6 className="section-title text-start text-primary text-uppercase mb-4">
                      {section.header}
                    </h6>
                    {section.UnitItem.map((item, itemIndex) => (
                      <Link to={item.path} className="btn btn-link" key={itemIndex}>
                        {item.name}
                      </Link>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
